export const SessionConstant = {
    SESSION_VALIDITY_CHECK_INITIATED : 'SESSION_VALIDITY_CHECK_INITIATED',
    SESSION_VALIDITY_STATUS_RECEIVED : 'SESSION_VALIDITY_STATUS_RECEIVED',
    SESSION_VALIDITY_CHECK_FAILED : 'SESSION_VALIDITY_CHECK_FAILED',
};